import { createContext, useContext, useMemo } from 'react';
import uniqueId from 'transmute/uniqueId';
import { jsx as _jsx } from "react/jsx-runtime";
const IdentifierContext = /*#__PURE__*/createContext(undefined);
export const IdentifierProvider = ({
  children,
  formMetadata
}) => {
  const inputId = useMemo(() => uniqueId('input-'), []);
  const formId = formMetadata === null || formMetadata === void 0 ? void 0 : formMetadata.formId;
  const formNodeId = formMetadata === null || formMetadata === void 0 ? void 0 : formMetadata.formNodeId;
  const value = useMemo(() => ({
    formId,
    formNodeId,
    inputId
  }), [formId, formNodeId, inputId]);
  return /*#__PURE__*/_jsx(IdentifierContext.Provider, {
    value: value,
    children: children
  });
};
export const useIdentifierContext = () => {
  const context = useContext(IdentifierContext);
  if (context === undefined) {
    throw new Error('useIdentifierContext must be used within a IdentifierProvider');
  }
  return context;
};